import React from "react";
import { router, usePage } from "@inertiajs/react";
import { useTrack } from "@/Logigate/hooks/useTrack";
import { SeletorDoGrupo } from "./SeletorDoGrupo";

interface Escola {
    id: number;
    nome: string;
    tipo: number;
}

interface EscolaSeletorProps {
    escolas: Escola[];
    escolaSelecionadaId: number;
    onEscolaChange?: (escola: Escola, menu: any[]) => void;
}

/**
 * A escola do grupo «Escola Inteligente». Ao trocar, pede o menu da escola, actualiza o menu
 * em memória e abre o painel dela: o URL (`?escola_id=`) é a fonte da verdade, por isso a
 * escolha não fica guardada no aparelho.
 */
export default function EscolaSeletor({ escolas, escolaSelecionadaId, onEscolaChange }: EscolaSeletorProps) {
    const { props } = usePage<any>();
    const { track } = useTrack("escola");

    return (
        <SeletorDoGrupo
            itens={escolas}
            selecionadoId={escolaSelecionadaId}
            caminhoMenu={(id) => `/escola-inteligente/menu/${id}`}
            icone="solar:mortarboard-bold"
            rotulo="Escola"
            placeholder="Escolher a escola"
            nadaEncontrado="Nenhuma escola encontrada"
            textoErro="Não foi possível carregar o menu da escola. Tenta de novo."
            aoEscolher={(escola) => track("clicou", "escola_selecionar_escola", { md: { escola_id: escola.id, escola_nome: escola.nome } })}
            onTrocar={(escola, menu) => {
                // O menu em memória passa a ser o da escola escolhida, para o menu a reflectir
                // logo, mesmo que o casco volte a montar na navegação.
                if (typeof window !== "undefined" && Array.isArray(window.empresa_navigation)) {
                    const escolaItem = (window.empresa_navigation as any[]).find((i) => i?.nome === "Escola Inteligente");
                    if (escolaItem) {
                        escolaItem.submenu = menu;
                        escolaItem.escola_selecionada_id = escola.id;
                    }
                }
                onEscolaChange?.(escola, menu);
                // O conteúdo da página e o menu ficam iguais, mesmo depois de recarregar.
                router.visit(props.base_path + `/escola-inteligente/?escola_id=${escola.id}`);
            }}
        />
    );
}
